import React from 'react';
import { Scissors, Sparkles, Droplets, HeartPulse } from 'lucide-react';
const services = [{
  title: 'Full Grooming & Haircut',
  description: 'Complete style with breed-specific cuts.',
  icon: <Scissors size={28} data-id="element-197" />,
  image: 'https://cdn.magicpatterns.com/uploads/qXmmaTm6hoyMX8ccWUDew6/full-grooming.jpg'
}, {
  title: 'Blueberry Facial',
  description: 'A gentle, aromatic facial treatment pets love.',
  icon: <Sparkles size={28} data-id="element-198" />,
  image: 'https://cdn.magicpatterns.com/uploads/twABoL3tMCxBJBTm63zSjc/blueberry-facial.jpg'
}, {
  title: 'Shampoo, Condition & Dry',
  description: 'Premium products. Silky results.',
  icon: <Droplets size={28} data-id="element-199" />,
  image: 'https://cdn.magicpatterns.com/uploads/1vx5C6Nn9QvAkapbbEyL42/shampoo.jpg'
}, {
  title: 'Nail Clipping & Teeth',
  description: 'The finishing touches every pet deserves.',
  icon: <HeartPulse size={28} data-id="element-200" />,
  image: 'https://cdn.magicpatterns.com/uploads/frqJpWGCXdhx9XhkQqt3kN/nail-clipping.jpg'
}];
export function Services() {
  return <section id="services" className="py-24 bg-brand-light" data-id="element-201">
      <div className="container mx-auto px-6 md:px-12" data-id="element-202">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-203">
          <h2 className="text-4xl md:text-5xl font-heading text-brand-dark mb-4" data-id="element-204">
            What We Offer
          </h2>
          <p className="text-lg text-brand-gray/80" data-id="element-205">
            From a quick bath to a full luxury package — we do it all.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-206">
          {services.map((service, index) => <div key={index} className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-2 border border-gray-100 hover:border-brand-orange" data-id="element-207">
              <div className="h-48 overflow-hidden relative" data-id="element-208">
                <div className="absolute inset-0 bg-brand-dark/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-209" />
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-210" />
              </div>
              <div className="p-6 relative" data-id="element-211">
                <div className="absolute -top-8 right-6 w-16 h-16 bg-brand-dark text-brand-orange rounded-2xl flex items-center justify-center shadow-lg transform group-hover:rotate-12 transition-transform duration-500 z-20" data-id="element-212">
                  {service.icon}
                </div>
                <h3 className="text-xl font-heading text-brand-dark mb-2 mt-4 pr-12" data-id="element-213">
                  {service.title}
                </h3>
                <p className="text-brand-gray/70 text-sm" data-id="element-214">
                  {service.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-215">
          <a href="#book" className="inline-block bg-brand-dark text-brand-light px-8 py-4 rounded-full font-semibold hover:bg-brand-orange transition-colors duration-300 min-h-[48px]" data-id="element-216">
            See Full Pricing & Packages
          </a>
        </div>
      </div>
    </section>;
}